(function () {
  
  const productVariants = document.querySelector('product-variants');
  const productVariantsInput = productVariants.querySelectorAll('.product-variant__input');
  const variantsEl = productVariants.querySelectorAll('[data-js-product-variant]');

  if(productVariants && productVariants.querySelector('.product-variant__input')) {
    productVariants.addEventListener('variantChange', function (e) {
      var variant = e.target.currentVariant;
      var variantData = e.target.variantData;
      var trigger = e.detail.trigger;

      if(variant) {
        const totalVariants = e.target.dataset.variants;
        const variantsElem = e.target.querySelectorAll('[data-js-product-variant]');
        var option1 = variant.option1;
        var option2 = variant.option2 ? variant.option2 : false,
            option3 = variant.option3 ? variant.option3 : false;
  
        if(totalVariants > 1) {
          var sameOption1 = variantData.filter(function(obj) {
            return obj.option1 == option1;
          });
          var productVariantsElem = [];
          for (let i = 1; i < totalVariants; i++) {
            let variantsElement = variantsElem[i];
            let variantInputs = variantsElement.querySelectorAll('.product-variant__input');
            let productVariantsElem2 = false;
            let productVariantsElem3 = false;
            variantInputs.forEach(variantInput => {
              let optionValue = variantInput.value;
              if(option2 && i == 1) {
                let optionAvailable = false;
                var sameOption2 = sameOption1.filter(function(obj) {
                  return obj.option2 == optionValue;
                });
                for (let j = 1; j < sameOption2.length; j++) {
                  let variantObj = sameOption2[j];
                  if(variantObj.available) optionAvailable = true;
                }
                if(!optionAvailable) variantInput.classList.add('disabled');
                else variantInput.classList.remove('disabled');
              }
            });
          }
          var productVariantIndex = getProductVariant(trigger);
          if(productVariantIndex !== false || productVariantIndex < 3) {
            var variantEl = variantsEl[++productVariantIndex];
            if(variantEl) {
              
              var variantsInput = variantEl.querySelectorAll('.product-variant__input:not(.disabled)')
              if(variantsInput.length > 0) {
                variantsInput[0].checked = false;
                variantsInput[0].closest(".product-variant__item").querySelector('.product-variant__label').click();
              }
            }
          }
        }
      }
      
    })
  }
  
  var getProductVariant = function(value) {
    var index = false;
    for (i = 0; i < variantsEl.length; i++) {
      var variantEl = variantsEl[i]
      if(variantEl.querySelector('.product-variant__input[value="'+value+'"]')) {
        return i;
      }
    }
  }

})();
